import React, { useEffect, useRef, useState } from 'react';
import '../../assets/css/LoginPage.css';
import companyLogo from '../../assets/Images/companylogo.png';
import collegeLogo from '../../assets/Images/college-logo.png';
import { Postdata } from '../../API/GlobalApi';
import Notifier from "../../Utils/notify";
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../Store/AuthSlice/AuthSlice';
import Session from '../../Utils/Sessions';
const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [isOtpFilled, setIsOtpFilled] = useState(false);
  const [getotpdisp, setgetotpdisp] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [timerRunning, setTimerRunning] = useState(false);
  const otpInputs = useRef([]);
  const phoneInputRef = useRef(null);

  const [loading, setLoading] = useState(false);




  const handleChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value.replace(/\D/g, ''));
  };

  const Getotp = async () => {
    setLoading(true);
    try {
      const data = { mobile: phoneNumber };
      const url = 'core/send-login-otp/';
      const response = await Postdata(url, data);
      if (response && !response.error) {
        setgetotpdisp(true);
        startTimer();
        setTimeout(() => {
          otpInputs.current[0]?.focus();
        }, 100);
      } else {
        Notifier.error(response?.error || "Failed to send OTP. Please try again.");
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      Notifier.error("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const dispatch = useDispatch()

  const navigate = useNavigate()
  const startTimer = () => {
    if (!timerRunning) {
      setTimerRunning(true);
      setCountdown(60);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setTimerRunning(false);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, '');
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      otpInputs.current[index + 1]?.focus();
    } else if (value === '' && index > 0) {
      otpInputs.current[index - 1]?.focus();
    }

    setIsOtpFilled(newOtp.every((digit) => digit.length === 1));
  };

  // Convert permission names to slug format
  const normalizePermission = (p = "") => {
    if (typeof p !== "string") return "";
    return p.toLowerCase().trim().replace(/\s+/g, "-");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!getotpdisp) {
      if (phoneNumber.length === 10) Getotp();
      setLoading(false);
      return;
    }

    // Step 2: Verify OTP
    const url = "core/login/";
    const data = { mobile: phoneNumber, otp: otp.join("") };
    const response = await Postdata(url, data);

    if (!response.error) {
      const fullName = response?.full_name;


      const loginMsg = `Login successful — Welcome ${fullName}`;

      Notifier.success(loginMsg);
      // Notifier.success(response?.message);
      Session.set("security_pin", response?.security_pin);


      const perms = (response.permissions || []).map(normalizePermission);

      dispatch(
        setCredentials({
          token: response.token,
          user_details: {
            id: response.user_id,
            profile_image: "",
            profile: response.profile,
            full_name: response.full_name,
          },
          message: response.message,
          permissions: perms,
        })
      );

      // --------------------------
      // REDIRECT LOGIC STARTS HERE
      // --------------------------

      const FINANCE_PERMISSIONS = [
        "can-view-finance-dashboard",
        "can-view-finance-analytics",
        "can-view-online-payment-report",
        "can-approve-course-fee-plan",
        "can-approve-course-fee-schedule",
        "can-give-discount",
        "can-approve-discount",
        "can-receive-payment",
        "can-reconcile-payments",
        "can-reconcile-self-payments",
        "can-view-bank-accounts",
        "can-view-discount",
        "can-view-schedule-and-fee",
        "can-view-payments",
        "can-view-student-ledger",
        "can-view-student-ledger-details",
        "can-view-transactions",
        "impose-fee-due",
      ];

      // ✅ Check if any finance permission exists
      const hasFinance = perms.some((p) => FINANCE_PERMISSIONS.includes(p));

      if (hasFinance) {
        navigate("/finance/dashboard");
        return;
      }

      // --------------------------
      // NON-FINANCE SINGLE PERMISSION REDIRECTS
      // --------------------------

      if (perms.includes("can-view-activity")) {
        navigate("/manage-activities");
        return;
      }

      if (perms.length === 1) {
        const only = perms[0];

        if (only === "can-view-contest") {
          navigate("/contest");
          return;
        }

        if (only === "can-view-student") {
          navigate("/studentDashboard");
          return;
        }

        if (only === "can-view-inquiry") {
          navigate("/enquiry-dashbord");
          return;
        }

        if (only === "can-view-data-profiles") {
          navigate("/OrganisationDashboard");
          return;
        }

        if (only === "can-view-library-noc") {
          navigate("/manage-library-noc")
          return
        }
      }

      // --------------------------
      // DEFAULT REDIRECT
      // --------------------------

      navigate("/studentDashboard");

    } else {
      Notifier.error(response.error || "Wrong OTP");
    }

    setLoading(false);
  };

  const handleResendOtp = () => {
    if (!timerRunning) {
      startTimer();
      Getotp();
    }
  };

  useEffect(() => {
    otpInputs.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (!getotpdisp) {
      phoneInputRef.current?.focus();
    }
  }, [getotpdisp]); // Runs on mount and when OTP display changes


  return (
    <>
      <div className="containers">
        <div className="background-section"></div>

        <div className="login-panel">
          <div>
            <div className="logo">
              <img src={collegeLogo} alt="College Logo" />
            </div>

            <h2 className='loginTitle'>Login to your account</h2>

            <form onSubmit={handleSubmit} className='loginForm'>
              {!getotpdisp ? (
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <div className="phone-input">
                    <select name="countryCode" id="countryCode" defaultValue="+91" className='selectPhone'>
                      <option value="+91">🇮🇳 +91</option>
                      <option value="+1">🇺🇸 +1</option>
                      <option value="+44">🇬🇧 +44</option>
                      <option value="+61">🇦🇺 +61</option>
                    </select>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      value={phoneNumber}
                      onChange={handleChange}
                      maxLength="10"
                      required
                      ref={phoneInputRef}
                    />
                  </div>
                  <button
                    type="submit"
                    className="login-button mt-3"
                    disabled={phoneNumber.length !== 10}
                    style={{
                      width: '100%',
                      padding: '10px',
                      backgroundColor: phoneNumber.length === 10 ? '#7F56DA' : '#d3d3d3',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: phoneNumber.length === 10 ? 'pointer' : 'not-allowed',
                      marginTop: '20px',
                    }}
                  >
                    {loading ? <span className="spinner-border spinner-border-sm" /> : "Send OTP"}
                  </button>
                </div>
              ) : (
                <>
                  <p className="otp-label">
                    Please enter the 6 digit OTP sent to <strong>{phoneNumber}</strong>
                  </p>
                  <div
                    style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}
                    className="otp-input"
                  >
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        value={digit}
                        ref={(el) => (otpInputs.current[index] = el)}
                        onChange={(e) => handleOtpChange(e, index)}
                        maxLength="1"
                        style={{
                          width: '40px',
                          height: '40px',
                          textAlign: 'center',
                          margin: '0 5px',
                          fontSize: '16px',
                        }}
                        required
                      />
                    ))}
                  </div>
                  <button
                    type="submit"
                    className="login-button mt-3"
                    disabled={!isOtpFilled}
                    style={{
                      width: '100%',
                      padding: '10px',
                      backgroundColor: isOtpFilled ? '#7F56DA' : '#d3d3d3',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: isOtpFilled ? 'pointer' : 'not-allowed',
                      marginTop: '20px',
                    }}
                  >
                    {loading ? <span className="spinner-border spinner-border-sm" /> : "Login"}
                  </button>
                  {timerRunning ? (
                    <p className="otp-label mt-3">Resend OTP in {countdown}s</p>
                  ) : (
                    <p className="otp-label resend mt-3" onClick={handleResendOtp}>
                      Resend OTP
                    </p>
                  )}
                </>
              )}
            </form>
          </div>

          <div className="product-footer">
            <div className="product-name">
              IMROS
              <span>Institute Management & Resource Optimization Solution</span>
            </div>
            <div className="company-brand">
              <span>Powered by</span>
              <img src={companyLogo} alt="Sort String Solutions Logo" />
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default Login;
